/** Removes mask punctuation only; keeps A–Z and 0–9. */
export function normalizeDocument(value?: string | null): string {
  if (!value) return '';
  return value
    .replace(/[.\/\-\(\)\s]/g, '')
    .toUpperCase();
}

/** Strips non-digits — use only for CPF-only fields. */
export function onlyDigits(value?: string | null): string {
  return value?.replace(/\D/g, '') ?? '';
}
